function hideCounterIfNoFilterOptions() {
  var url = window.location.pathname + window.location.search;
  // Only add the class if there is no filter, or if there are filters other than 'filter.v.availability=1'
  // Check if there are no filters applied (no 'filter' in URL)
  // OR only the availability filter is applied (no other filters)
  var hasFilter = url.includes("filter");
  var onlyAvailabilityFilter = hasFilter && url.includes("filter.v.availability=1") && url.replace(/[?&]filter.v.availability=1/, "").includes("filter") === false;

  if (!hasFilter || onlyAvailabilityFilter) {
    document.body.classList.add("count-hide");
  } else {
    document.body.classList.remove("count-hide");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  hideCounterIfNoFilterOptions();
});

document.addEventListener("collection:loading", function () {
  // Always check the checkbox with name 'filter.v.availability' and value '1'
  var checkbox = document.querySelector('input[name="filter.v.availability"]');
  if (checkbox) {
    checkbox.checked = true;
    // Optionally, trigger change event if needed
    checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

document.addEventListener("collection:reloaded", function () {
  hideCounterIfNoFilterOptions();
});
